import { gql } from '@apollo/client';

export const EXPORT_FUNDER_SCHOOL_PROMOTION = gql`
  query ExportFunderSchoolPromotion($input: ExportArgs!) {
    exportFunderSchoolPromotion(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      schoolPromotionData {
        id
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          name
          value
        }
        gradeAverage
        numberEnrolled
        numberPassed
        numberWrote
        percentagePassed
        promotionStatus {
          name
        }
        term
        year
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
